import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectGamesLoading, selectPopularGames } from '@/store/games/selectors';

import { BffGamesCategory } from '@lucky7ventures/bff-types';
import { isEmpty } from '@/shared/utility';
import Streamline from '@/components/shared/streamline/Streamline';
import { AbsoluteLink } from '@/components/AbsoluteLink';
import classNames from 'classnames';
import { gameThumbImgHero } from '@/utils/image-utils';
import { shuffleArray } from '@/utils/utils';

const HomeHeroPopularGames = () => {
  const games = useSelector(selectPopularGames);
  const loading = useSelector(selectGamesLoading);

  const children = useMemo(() => {
    if (isEmpty(games) || loading) return <div />;
    return shuffleArray(games).map(game => (
      <div
        className="flex flex-col w-full max-w-[80px] md:max-w-[140px] flex-shrink-0"
        key={`/${BffGamesCategory.Popular}/${game.slug}/${game.gameId}`}
      >
        <AbsoluteLink
          to={`/games/${game.slug}/${game.gameId}`}
          title={game.name}
          className={classNames(
            'relative rounded-2xl w-full h-full overflow-hidden flex flex-col snap-start shadow-sm',
          )}
          data-cy={`hero-popular-game-${game.slug}`}
        >
          <img
            className="w-full h-full object-cover object-top"
            alt={game.name}
            src={gameThumbImgHero(game.slug)}
          />
        </AbsoluteLink>
      </div>
    ));
  }, [games, loading]);

  return (
    <div className="mx-auto pb-[24px]">
      <Streamline children={children} />
    </div>
  );
};

export default HomeHeroPopularGames;
